<div class="header">
  <i class="fa fa-plus-circle"></i> <div class="text">Productos (Total: {{order?.total | money}})</div>
</div>
<div class="wrapper">
  <div class="content">
    @if(order){
      @for (item of order.inventory_action_for_consume.inventory_action_products; track $index) {
        <div class="item info">
          <div class="quantity">{{item.quantity}}</div>
          <div class="value">{{item.product.code}} - {{item.product.name}}</div>
          <div class="name right">{{item.amount*item.quantity | money}}</div>
        </div>
      }
      <div class="info">
        <div class="quantity"></div>
        <div class="value">Neto</div>
        <div class="name right">{{order.total | money }}</div>
      </div>
      <div class="info">
        <div class="quantity"></div>
        <div class="value">IVA</div>
        <div class="name right">{{order.total*0.19| money }}</div>
      </div>
      <div class="info last">
        <div class="quantity"></div>
        <div class="value">Total</div>
        <div class="name right total" style="text-align: right">{{order.total*1.19 | money }}</div>
      </div>
    }
    <button mat-raised-button (click)="generatePayment()" *ngIf="!parentForm.valid" [disabled]="working" color="accent">Enviar Cobro a Cliente</button>
    <span class="success" *ngIf="parentForm.valid"><i class="fa fa-check-circle"></i>Cobro enviado exitosamente <span class="see" (click)="openPayment()">Ver</span></span>
  </div>
</div>
